import {
    getFirestore,
    collection,
    getDocs,
    doc,
    getDoc,
    updateDoc,
    serverTimestamp,
    query,
    orderBy
} from 'firebase/firestore';

const CHART_DOC_ID = '9gYzl8127rQ9kosWpRCy';
const CHART_COLLECTION = 'top100Chart';
const TRACKS_COLLECTION = 'trackLinks';

export const Top100OrganizerService = {
    async updateTop100Charts() {
        const db = getFirestore();
        try {
            const tracksCol = collection(db, TRACKS_COLLECTION);
            const snapshot = await getDocs(tracksCol);
            if (snapshot.empty) return;

            const allTrackIds = snapshot.docs.map((doc) => doc.id);

            for (let i = allTrackIds.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [allTrackIds[i], allTrackIds[j]] = [allTrackIds[j], allTrackIds[i]];
            }

            const selectedIds = allTrackIds.slice(0, 100);
            const chartRef = doc(db, CHART_COLLECTION, CHART_DOC_ID);

            await updateDoc(chartRef, {
                chartTrackIDs: selectedIds,
                lastUpdated: serverTimestamp(),
                lastShuffledAt: serverTimestamp()
            });
        } catch (error) {
            console.error("Error in updateTop100Charts:", error);
            throw error;
        }
    },

    async fetchCurrentChart() {
        const db = getFirestore();
        const docRef = doc(db, CHART_COLLECTION, CHART_DOC_ID);
        const snapshot = await getDoc(docRef);
        return snapshot.exists() ? snapshot.data() : null;
    },

    async fetchAllTracks() {
        const db = getFirestore();
        const tracksCol = collection(db, TRACKS_COLLECTION);

        const snapshot = await getDocs(tracksCol);

        const tracks = snapshot.docs.map(doc => ({
            id: doc.id,
            title: doc.data().trackTitle || "Untitled",
            artistName: doc.data().artistName || "Unknown Artist",
            releaseDate: doc.data().releaseDate,
            ...doc.data()
        }));

        return tracks.sort((a, b) => {
            const dateA = a.releaseDate?.seconds || 0;
            const dateB = b.releaseDate?.seconds || 0;
            return dateB - dateA;
        });
    },

    async updateChartOrder(newTrackIDs: string[]) {
        const db = getFirestore();
        const docRef = doc(db, CHART_COLLECTION, CHART_DOC_ID);
        await updateDoc(docRef, {
            chartTrackIDs: newTrackIDs,
            lastUpdated: serverTimestamp()
        });
    }
};